<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-row>
        <NewViewEditProductPurchase
          v-model="showNewViewEditPurchaseProductDialog"
        />
        <view-user :user-id="selectedUser"
                   v-model="viewUserDialog"
                   @clearUserIdAndAuths="clearUserIdAndAuths()"
                   @getUsers="getPurchaseProducts()"/>

        <v-col cols="12" class="d-flex justify-space-between align-center">
            <v-text-field :hint="$t('general.search')"
                          clearable
                          class="mr-3"
                          color="kbDarkBlue"
                          :placeholder="$t('general.search')"
                          v-model="search">
                <template v-slot:append-outer>
                    <v-icon color="kbDarkBlue" @click="getPurchaseProducts" class="ml-2">refresh</v-icon>
                </template>
            </v-text-field>
        </v-col>

        <v-col class="text-h6" cols="12">
            <v-data-table class="elevation-2"
                          :headers="headers"
                          :items="purchaseProducts"
                          :loading="loadingPurchaseProducts"
                          :options.sync="optionsPurchaseProducts"
                          :footer-props="{
                            'items-per-page-text': `${$t('general.productPurchases')} ${$t('general.perPage')}`,
                            'items-per-page-options': [50, 100, 200]
                          }"
                          :server-items-length="totalPurchaseProducts">
                <template v-slot:item="{ item }">
                  <tr>
                    <td class="font-weight-bold text-capitalize">{{ item._id }}</td>
                    <td class="font-weight-bold text-capitalize">{{ item.paymentInfo && item.paymentInfo.paymentMethod }}</td>
                    <td class="font-weight-bold text-capitalize">{{ item.status.value }}</td>
                    <td class="font-weight-bold text-capitalize">{{ item.shippingAddress }}</td>
                    <td class="font-weight-bold">{{ item.payAmount }}</td>
                    <td>{{ item.date | moment('DD/MM/YYYY hh:mma') }}</td>
                    <td class="ma-0 pa-0">
                      <div class="data-table-actions d-flex justify-center align-center">
                        <v-btn @click="showProductPurchase(item)" color="kbDarkBlue" text icon>
                            <v-icon>remove_red_eye</v-icon>
                        </v-btn>
                        <v-btn @click="showUser(item.userIdHash)" color="kbDarkBlue" text icon>
                            <v-icon>mdi-account</v-icon>
                        </v-btn>
                      </div>
                    </td>
                  </tr>
                </template>

                <template v-slot:no-data>
                    <v-row>
                        <v-col class="text-center" v-if="loadingPurchaseProducts" cols="12">
                            {{ $t('general.loadingProductPurchase') }}
                        </v-col>
                        <v-col class="red--text text-center" v-else cols="12">
                            {{ $t('general.noProductPurchasesRegistered') }}
                        </v-col>
                    </v-row>
                </template>
            </v-data-table>
        </v-col>
    </v-row>
</template>

<script>
import { mapState } from 'vuex'
import NewViewEditProductPurchase from '@/pages/App/Events/EventsPurchases/dialogs/NewViewEditProductPurchase'
import ViewUser from '@/pages/App/People/dialogs/ViewUser/ViewUser'

export default {
  components: {
    NewViewEditProductPurchase,
    ViewUser
  },
  computed: {
    ...mapState({
      selectedApp: state => state.apps.selectedApp,
      purchaseProducts: state => state.events.purchaseProducts,
      totalPurchaseProducts: state => state.events.totalPurchaseProducts,
      loadingPurchaseProducts: state => state.events.loadingPurchaseProducts
    }),
    search: {
      get () {
        return this.$store.state.events.searchPurchaseProducts
      },
      set (value) {
        this.$store.commit('SET_SEARCH_PURCHASE_PRODUCTS', value)
      }
    },
    isSearching () {
      return this.search && this.search !== ''
    },
    optionsPurchaseProducts: {
      get () {
        return this.$store.state.events.optionsPurchaseProducts
      },
      set (value) {
        this.$store.commit('SET_PAGINATION_PURCHASE_PRODUCTS', value)
      }
    },
    showNewViewEditPurchaseProductDialog: {
      get () {
        return this.$store.state.events.showNewViewEditPurchaseProductDialog
      },
      set (value) {
        this.$store.commit('SET_SHOW_NEW_VIEW_EDIT_PURCHASE_PRODUCT_DIALOG', value)
      }
    },
    headers () {
      return [
        { text: this.$t('general.purchaseId'), value: 'status._id' },
        { text: this.$t('general.purchasePaymentMethod') },
        { text: this.$t('general.status'), value: 'status.value' },
        { text: this.$t('general.shippingAddress'), value: 'shippingAddress' },
        { text: this.$t('general.payAmount'), value: 'payAmount' },
        { text: this.$t('general.paymentDate'), value: 'date' },
        { text: this.$t('general.actions'), align: 'center', sortable: false, value: '' }
      ]
    }
  },
  created () {
  },
  data () {
    return {
      viewUserDialog: false,
      selectedUser: ''
    }
  },
  methods: {
    getPurchaseProducts () {
      this.$store.dispatch('getPurchaseProducts')
    },
    showProductPurchase (purchase) {
      this.$store.commit('SET_METHOD_NEW_VIEW_EDIT_PURCHASE_PRODUCT', 'view')
      const newPurchase = Object.assign({}, purchase)
      this.$store.commit('SET_SELECTED_PURCHASE_PRODUCT', newPurchase)
      this.showNewViewEditPurchaseProductDialog = true
    },
    showUser (userId) {
      this.selectedUser = userId
      this.viewUserDialog = true
    },
    clearUserIdAndAuths () {
      this.selectedUser = ''
    }
  },
  watch: {
    optionsPurchaseProducts: {
      handler () {
        this.getPurchaseProducts()
        this.$vuetify.goTo(0)
      },
      deep: true
    },
    search () {
      console.log(this.search)
      this.optionsPurchaseProducts.page = 1

      this.getPurchaseProducts()
    },
    selectedApp () {
      this.getPurchaseProducts()
    }
  }
}
</script>
